export default __webpack_public_path__ + "static/media/back.b9714d98.webp";